/**
 * PARA ONDE VOLTAR DEPOIS DE ENTRAR — `T8.24`.
 *
 * Ele, na letra: *"Ao abrir /minha-conta deslogado, o site manda para o login (correto), mas depois de
 * entrar leva **sempre** para 'Meus quadrinhos'."*
 *
 * ── A CAUSA, E ELA ESTAVA PREVISTA NA PROVA DO PRÓPRIO NÓ ───────────────────────────────────
 *
 * O destino de volta **já existia**: a tela de login lê `state.voltarPara` e vai para lá depois de
 * entrar, e a guarda do acervo (`meus-quadrinhos/guarda.tsx`) o passa certo, com
 * `pathname + search`. Mas duas telas chamavam `navigate("/login")` **sem estado nenhum** —
 * `minha-conta.tsx` e `sign-up.tsx` no modo de edição. Sem `voltarPara`, o login cai no padrão, que é
 * "Meus quadrinhos".
 *
 * A prova do `TS-T8.15.1` já dizia isso em 24/09: *"é provável que só o caminho de /minha-conta não o
 * passe"*. Era.
 *
 * ── POR QUE ISTO É UM ARQUIVO DE TRÊS LINHAS ────────────────────────────────────────────────
 *
 * Porque a informação que o login precisa são **duas** — para onde voltar e por quê —, e quem escreve
 * o objeto na mão esquece a segunda. Foi o que aconteceu: a guarda passava as duas, as outras duas
 * telas passavam zero, e nada acusava. Agora é uma chamada, e a terceira tela que aparecer copia a
 * chamada em vez de reinventar o objeto.
 */

/** O motivo de a pessoa ter sido mandada ao login. A tela usa isto para dizer a coisa certa. */
export type MotivoDoLogin = "sem-conta" | "email-nao-verificado";

export interface DestinoDeVolta {
  /** Para onde voltar. Sempre `pathname + search`: um destino que perde o parâmetro mente. */
  voltarPara: string;
  motivo: MotivoDoLogin;
}

/**
 * O estado a passar em `navigate("/login", { state: ... })`.
 *
 * `temConta` decide o motivo: quem já tem conta e não verificou o e-mail não precisa ouvir que
 * precisa criar uma — precisa ouvir que falta verificar.
 */
export function paraOndeVoltar(
  local: { pathname: string; search?: string },
  temConta: boolean
): DestinoDeVolta {
  return {
    voltarPara: local.pathname + (local.search ?? ""),
    motivo: temConta ? "email-nao-verificado" : "sem-conta",
  };
}
